import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { alpha, useTheme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

LoginAccessTag.propTypes = {
  label: PropTypes.string.isRequired,
  sx: PropTypes.object
};

export default function LoginAccessTag({ label, sx: sxProp }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 2.5,
        px: { xs: 2, sm: 2.25 },
        py: 0.85,
        maxWidth: '100%',
        borderRadius: '999px',
        bgcolor: alpha(theme.palette.primary.main, 0.1),
        border: `1px solid ${alpha(theme.palette.primary.main, 0.26)}`,
        boxShadow: `0 1px 3px ${alpha(theme.palette.primary.dark, 0.08)}`,
        ...sxProp
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: 'primary.dark',
          fontWeight: 600,
          letterSpacing: '0.03em',
          fontSize: { xs: '0.78rem', sm: '0.8125rem' },
          textAlign: 'center',
          lineHeight: 1.45
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
